import React from 'react';
import { CodetableTranslation } from 'app/area/codetable/constants';
import styles from './uom-heading.scss';
import { CodetableMetadata } from 'app/area/codetable/types-store';

interface UomHeadingProps {
  translation: CodetableTranslation;
  metadata: CodetableMetadata;
}

export const UomHeading = ({ metadata, translation }: UomHeadingProps) => {
  return <div className={styles.headingContainer}>
    <div className={styles.defaultColumn}>{metadata?.codetableCategory?.label ?? translation.uom_type}</div>
    <div className={styles.defaultColumn}>{translation.uom_description}</div>
    <div className={styles.fixedColumn} />
  </div>;
};
